// 005 slice / 007 (P-HOME-1): the parent Home's data, through the generated client. A context lets tests
// inject fakes. Lives in the parent area so parents never load school-admin code (006 FR-037).
import { createContext, useContext } from "react";

import { api } from "@/api";
import { type ApiClient, unwrap } from "@/api/client";
import type { Api } from "@/api/types";

export type HomeClient = {
  listLiveSchoolBanners(schoolId: string): Promise<Api["LiveBannerList"]>;
};

export function createHomeClient(client: ApiClient): HomeClient {
  return {
    listLiveSchoolBanners: (schoolId) =>
      unwrap(
        client.GET("/api/v1/schools/{schoolId}/banners/live", {
          params: { path: { schoolId } },
        }),
      ),
  };
}

export const HomeClientContext = createContext<HomeClient>(
  createHomeClient(api),
);
export const useHomeClient = () => useContext(HomeClientContext);
